import React from "react"
import CustomTable from "../../components/CustomTable";
import { addMaritalName, editMaritalName, getAllMaritalStatus, maritalUpdateApprovedAndUnapproved } from "../../services/ApiServices";
import { ApprovedAndUnApprovedBtn } from "../../components/ApprovedAndUnApprovedBtn";
import { EditButton } from "../../components/masterDataForm/EditButton";
import EditMasterForm from "../../components/masterDataForm/EditMasterForm";
import { AddButton } from "../../components/masterDataForm/AddButton";
import AddMasterForm from "../../components/masterDataForm/AddMasterForm";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const MaritalStatus = () => {

    const dispatch = useDispatch();
    const maritalsInfo = useSelector(state => state?.getAllMarital?.marital)

    const [showMarital, setMaritalShow] = React.useState(false);
    const [showAddMarital, setAddMaritalShow] = React.useState(false);
    const [maritalValName, setMaritalValName] = React.useState();


    React.useEffect(() => {
        const fetchUsers = async () => {
            try {
                const res = await getAllMaritalStatus();
                dispatch({type: 'GET_ALL_MARITAL', payload: res.data.data })
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    }, [dispatch]);

    
    const addMaritalHandle = async (maritalName) => {
        try {
            const addMaritalNames = await addMaritalName(maritalName);
            if(addMaritalNames.status === 200) {
                dispatch({ type: 'ADD_MARITAL_NAME', payload: addMaritalNames.data?.data})
                toast.success(addMaritalNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };
    const editMaritalNameHandle = async (maritals) => {
        try {
            const maritalPayload = {
                maritalId: maritals?.statusId,
                name: maritals?.name
            }
            const editMaritalNames = await editMaritalName(maritalPayload);
            if(editMaritalNames.status === 200) {
                dispatch({ type: 'UPDATE_MARITAL_NAME', payload: editMaritalNames.data?.data})
                toast.success(editMaritalNames.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };
    const maritalApprovedAndUnAprooved = async (statusId) => {
        try {
            const approvedAndUnapprovedStatus = await maritalUpdateApprovedAndUnapproved(statusId);
            if(approvedAndUnapprovedStatus.status === 200) {
                dispatch({ type: 'UPDATE_MARITAL_STATUS', payload: approvedAndUnapprovedStatus.data?.data})
                toast.success(approvedAndUnapprovedStatus.data?.message)
            }
        } catch (error) {
            toast.error(error.response?.data?.message)
        }
    };

    const colDefs = [
            { field: "name", flex: 2, headerName: 'Name' },
            { field: "isApproved", flex: 2, headerName: 'Status', cellRenderer: (val) => {
            return ( <ApprovedAndUnApprovedBtn status={val?.data?.isApproved} statusId={val.data._id} handleApprovedAndUnAprooved={maritalApprovedAndUnAprooved}/> )
            }
        },
            { field: '_id', flex: 2, headerName: 'Action', cellRenderer: (val) => {
                return ( <EditButton name={val.data.name} statusId={val.data._id} hadnleEditName={setMaritalValName} handleEditBtn={setMaritalShow}/>)
            } 
        }
        ];

    return(
        <React.Fragment>
            <div className="aside-heading"><h3>Marital Status</h3></div>
            <AddButton formName="Marital" handleAddBtn={setAddMaritalShow} />
            <CustomTable colDefs={colDefs} rowData={maritalsInfo} />
            <AddMasterForm formName="Marital" addMasterData={addMaritalHandle} showAddForm={showAddMarital} setShowAddForm={setAddMaritalShow}/>
            <EditMasterForm formName="Marital" editMasterDataName={maritalValName} editMasterData={editMaritalNameHandle} showEditForm={showMarital} setShowEditForm={setMaritalShow}/>
        </React.Fragment>
    )
};
export default MaritalStatus;